<template>
    <div class="userInfo-container">
        <el-card class="fatherCard">
            <div slot="header" class="clearfix">
                <el-breadcrumb separator="/" >
                    <el-breadcrumb-item class="currentLocation"><i class="el-icon-location-outline"></i> 当前位置</el-breadcrumb-item> 
                    <el-breadcrumb-item>个人中心</el-breadcrumb-item>                
                </el-breadcrumb>
            </div>
            <div class="card-container" >         
                <div class="left-card-container">
                    <el-card class="left-card">
                        <span class="selfSpan">个人信息</span>
                        <el-divider class="fullDivider"></el-divider>
                        <img src="../assets/avatar.jpeg" class="userImg" />
                        <el-divider ></el-divider>
                        <div class="betweenDiv">
                            <div><i class="el-icon-user-solid"></i><span >用户名称</span></div>  
                            <div><span>{{loginInfo.relayName}}</span></div> 
                        </div>
                        <el-divider></el-divider>
                        <div class="betweenDiv">
                            <div><i class="el-icon-phone"></i><span >手机号码</span></div>
                            <div><span>{{loginInfo.userTel}}</span></div>      
                        </div>
                        <el-divider></el-divider>
                        <div class="betweenDiv">
                            <div><i class="icon-treesourcejiaose"></i><span>所属角色</span></div>
                            <div><span>{{loginInfo.roles != [] ? loginInfo.roles[0].roleName : ''}}</span></div>   
                        </div>
                        <el-divider></el-divider>
                        <div class="betweenDiv">
                            <div><i class="el-icon-user"></i><span >用户性别</span></div>     
                            <div><span>{{loginInfo.userSex === "0" ? '女': '男'}}</span></div>    
                        </div>
                    </el-card>
                </div>
                <div class="right-card-container">
                    <el-card class="right-card">
                        <span class="selfSpan">个人资料</span>
                        <el-divider class="fullDivider"></el-divider>
                        <el-tabs v-model="activeName" >
                            <el-tab-pane label="基本资料" name="first">
                                <el-form ref="modifyForm" :rules="modifyRules" :model="modifyForm" label-width="80px">
                                    <el-form-item label="用户姓名" prop="relayName">
                                        <el-input v-model="modifyForm.userId" v-if="false"></el-input>
                                        <el-input v-model="modifyForm.relayName" auto-complete="off"></el-input>
                                    </el-form-item>
                                    <el-form-item label="手机号码" prop="userTel">
                                        <el-input v-model="modifyForm.userTel"></el-input>
                                    </el-form-item>
                                    <el-form-item label="性别" >
                                        <el-radio-group v-model="modifyForm.userSex">
                                            <el-radio :label="1">男</el-radio>
                                            <el-radio :label="0">女</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                </el-form>
                                <el-button type="primary" size="mini" @click="modifySubmit('modifyForm')" class="subBtn">保存</el-button>
                                <el-button type="danger" size="mini" @click="toWelcome()">关闭</el-button>
                            </el-tab-pane>
                            <el-tab-pane label="修改密码" name="second">
                                <el-form ref="passwordForm" :model="passwordForm" :rules="passwordRules" label-width="80px">
                                    <el-form-item label="旧密码">
                                        <el-input v-model="passwordForm.oldPassword"></el-input>
                                    </el-form-item>
                                    <el-form-item label="新密码" prop="newPassword">
                                        <el-input v-model="passwordForm.newPassword"></el-input>
                                    </el-form-item>
                                </el-form>
                                <el-button type="primary" size="mini" @click="modifyPasswordSubmit('passwordForm')" class="subBtn">保存</el-button>
                                <el-button type="danger" size="mini" @click="toWelcome()">关闭</el-button>
                            </el-tab-pane>
                        </el-tabs>                    
                    </el-card>
                </div>
            </div>
        </el-card>               
    </div>  
</template>

<script>
import {modifyUserInfo } from '../api/user'
export default {
    data() {
        return {
            loginInfo:{
                userId:'',
                username: '',
                password:'',
                userSex: '1',
                userTel:'',
                roles:'',
                relayName:'',
                email:''
            },
            modifyForm:{
                userId: '',
                relayName:'',
                userTel:'',
                userSex:'',
                
            },
            passwordForm:{
                oldPassword: '',
                newPassword: ''
            },
            activeName: 'first',
            modifyRules: {
                relayName: [
                    { required: true, message: '请输入姓名', trigger: 'blur' },
                    { min: 2, max: 5, message: '长度在 2 到 5 个字符',trigger: 'blur' },
                    { pattern: /^[\u4E00-\u9FA5]+$/, message: '用户名只能为中文',trigger: 'blur'}
                ],  
                userTel: [
                    { required: true, message: '请输入电话', trigger: 'blur' },
                    {validator:function(rule,value,callback){
                        if (/^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/.test(value) == false) {
                            callback(new Error("请输入正确的手机号"));
                        } else {
                            callback();
                        }
                    }, trigger: 'blur'}
                ],
            },
            passwordRules: {
                newPassword: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    { min: 3, max: 15, message: '长度在 3 到 15 个字符',trigger: 'blur' }, 
                ],
            }
        }
    },
    created() {
        this.loginInfo = JSON.parse(this.$store.state.loginInfo);
        this.initModifyForm();
    },
    methods: { 
        //初始化个人资料修改对象值
        initModifyForm(){
            this.modifyForm.email = this.loginInfo.email;
            this.modifyForm.password = this.loginInfo.password;
            this.modifyForm.relayName = this.loginInfo.relayName;
            this.modifyForm.roleIds = [this.loginInfo.roles[0].roleId];
            this.modifyForm.userId = this.loginInfo.userId;
            this.modifyForm.userName = this.loginInfo.userName;
            this.modifyForm.userSex = Number(this.loginInfo.userSex);
            this.modifyForm.userTel = this.loginInfo.userTel;
            //this.modifyForm = this.loginInfo
        },
        //修改基本资料提交（真实姓名，手机号码和性别）
        modifySubmit(modifyForm){
            this.$refs[modifyForm].validate((valid) => {
                if (valid) {  
                    console.log('修改资料：'+ JSON.stringify(this.modifyForm));
                    modifyUserInfo(JSON.stringify(this.modifyForm)).then(response => {
                        //console.log(response);                
                        if(response.data.code === 200){                      
                            this.$message({
                                message: '基本资料已保存！',
                                type: 'success'
                            });   
                            this.loginInfo.relayName = this.modifyForm.relayName;
                            this.loginInfo.userTel = this.modifyForm.userTel;
                            this.loginInfo.userSex = this.modifyForm.userSex;                      
                            this.$store.commit('saveLoginInfo', {loginInfo: JSON.stringify(this.loginInfo)});
                            this.initModifyForm();
                        }else{
                            this.$message({
                                message: response.data.msg,
                                type: 'error'
                            });  
                        }
                    })
                } else {
                    this.$message({
                        message: '基本资料信息格式填写错误，请修改后重试！',
                        type: 'error'
                    });  
                }
            });     
        },
        //修改密码提交
        modifyPasswordSubmit(passwordForm){
            if(this.passwordForm.oldPassword != this.loginInfo.password){
                this.$message({
                    message: '密码（旧）错误，您无权修改！',
                    type: 'error'
                });
                return
            }
            if(this.passwordForm.newPassword === this.loginInfo.password){
                this.$message({
                    message: '新密码和旧密码相同，无须修改！',
                    type: 'error'
                });
                return
            }
            this.$refs[passwordForm].validate((valid) => {
                if (valid) { 
                    this.modifyForm.password  = this.passwordForm.newPassword;
                    console.log('修改密码：'+ this.modifyForm);
                    modifyUserInfo(JSON.stringify(this.modifyForm)).then(response => {   
                        //console.log(response);         
                        if(response.data.code === 200){                      
                            this.$message({
                                message: '新密码已保存！',
                                type: 'success'
                            });
                            this.loginInfo.password = this.passwordForm.newPassword;
                            this.$store.commit('saveLoginInfo', {loginInfo: JSON.stringify(this.loginInfo)});
                            this.initModifyForm();
                            this.passwordForm = {};
                        }else{
                            this.$message({
                                message: response.data.msg,
                                type: 'error'
                            });  
                        }
                    })
                } else {
                    this.$message({
                        message: '密码格式填写错误，请修改后重试！',
                        type: 'error'
                    });  
                }
            });     
        },
        toWelcome(){
            this.$router.push({
                path: '/welcome',   
            });
                
        },
    }
};
</script>
<style lang="css" scoped>
    .fatherCard {
        height: 88vh;
    }
    .currentLocation {
        font-weight:bold
    }  
    .card-container {
        display: flex;
        justify-content: flex-start;
    }
    .left-card {
        width: 400px;       
        padding: -20px;
    }
    .right-card-container {
        margin-left: 20px;
    }
    .right-card {
        width: 900px;
        height: 375px;
    }
    .userImg {
        width: 120px;
        height: 120px;
        margin-left: 100px;
        border-radius: 50%;
    }
    .betweenDiv {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .fullDivider {
        width: 900px;
        margin-left: -20px;     
    }
    .el-divider {
        margin-top: 10px;
        margin-bottom: 10px;
    }
    .subBtn {
        margin-left: 50px;
    }
  
</style>
